// modifer: styles/jss/nextjs-material-kit-pro/pages/productStyle
import { grayColor, title, description } from 'styles/jss/original/base';

import modalStyle from 'styles/jss/nextjs-material-kit-pro/modalStyle';
import customCheckboxRadioSwitch from 'styles/jss/original/components/common/ui/customCheckboxRadioSwitchStyle';
import customSelectStyle from 'styles/jss/original/components/common/ui/customSelectStyle';

const styles = (theme) => ({
  ...customSelectStyle,
  ...customCheckboxRadioSwitch,
  ...modalStyle(theme),
  modal: {
    minWidth: '500px',
    '@media (max-width: 640px)': {
      margin: '24px',
      marginTop: '24px !important',
      minWidth: '280px'
    }
  },
  modalTitle: {
    fontWeight: '600',
    textAlign: 'center',
    marginLeft: '50px',
    color: grayColor[1]
  },
  title: {
    ...title,
    marginTop: '20px',
    minHeight: '32px',
    textDecoration: 'none'
  },
  description: {
    ...description,
    textAlign: 'center',
    margin: '0'
  },
  closeButton: {
    '&:hover,&:focus': {
      color: 'inherit',
      background: 'transparent'
    }
  }
});

export default styles;
